import { useStorage } from '@vueuse/core'
import { createI18n } from 'vue-i18n'
import { en, zhCN } from '../locales'

// 获取当前语言
const getLocale = () => {
  const storageLocale = useStorage('locale', 'zh-CN')
  const urlLocale = new URLSearchParams(window.location.search).get('locale')

  if (urlLocale) {
    storageLocale.value = urlLocale
    return urlLocale
  }

  return storageLocale.value
}

export const i18n = createI18n({
  legacy: false, // 更改为 false 以使用 Composition API 模式
  globalInjection: true,
  locale: getLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    zh: zhCN,
    en: en
  }
})

export default i18n
